export default {
    TRACKING: "GDAppTracking",
    SCORING: "Scoring",
    GAME_SUMMARY: "Game Summary",
    SUMMARY: "Summary",
    MOUNDBALL: "Moundball",
    HIGHLIGHTS: "Real-Time Highlights",
    RECENT_PLAYS: "Recent Plays",
    SCOREBOARD : "Scoreboard",
    WRAPUP: "Wrap",
    LIVE: "Live",
    CLICK: {
        LAUNCH: 'Launch Click'
    },
    GD5_APP_ASYNC_TRACKING: 'GD5_App_Async_Tracking',
    GD5_APP_ASYNC_TRACKING_SIMPLE: 'GD5_App_Async_TrackingSimple',
    GD5_APP_LINK_TRACKING: 'GD5_App_Link_Tracking',
    VIDEO_HIGHLIGHTS_PLAYLIST: "Video Highlights Playlist",
    PREMIUM_STATS: "Premium Stats",
    VIDEO_HIGHLIGHT_ALERT: "Video Highlight Alert",
    DOM_CONTENT_LOADED: "DOMContentLoaded",
    TEAMCOMPARISON: 'Team Comp',
    GD5_APP_PAGELOAD_TRACKING: 'GD5_App_Pageload_tracking'
};